var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle114(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "204.6885887123592 576.9880439284349 17.93109351407253 18.693364135794923",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M208.69,587.04c-.06-3.33,1.8-5.62,4.27-5.99,2.5-.37,4.66.94,5.46,3.32.95,2.84-1.64,6.94-4.59,7.28-1.41.16-2.71-.29-3.5-1.38-.82-1.14-1.3-2.52-1.64-3.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle114);
export default __webpack_public_path__ + "static/media/twinkle-1-14.eacb11c08907510158f663d5a4b4732f.svg";
export { ForwardRef as ReactComponent };